import { useLayoutEffect, type ReactNode } from 'react';
import { LocaleProvider, useLocale } from '../context/LocaleContext';
import { RouteLoadingState } from '../components/LoadingStates';
import { startTiming } from '../lib/performance';
function ApplicationInitializationGate({ children }: { children: ReactNode }) {
  const { initialized, locale, t } = useLocale();
  useLayoutEffect(() => {
    if (!initialized || typeof document === 'undefined') return;
    const finishInitialization = startTiming('application-initialization', { locale });
    document.documentElement.lang = 'en-PH';
    document.documentElement.dataset.bootstrapLocale = 'en';
    document.documentElement.dataset.appReady = 'true';
    if (typeof performance !== 'undefined' && 'mark' in performance && 'measure' in performance) {
      try {
        performance.mark('solargabay:application-initialization:end');
        performance.measure(
          'solargabay:application-initialization:bootstrap',
          'solargabay:application-initialization:start',
          'solargabay:application-initialization:end',
        );
      } catch {
        // The inline bootstrap mark is unavailable in tests and static rendering.
      }
    }
    finishInitialization();
  }, [initialized, locale]);
  if (!initialized) return <RouteLoadingState message={t('loading.route')} />;
  return children;
}
export function Providers({ children }: { children: ReactNode }) {
  return (
    <LocaleProvider>
      <ApplicationInitializationGate>{children}</ApplicationInitializationGate>
    </LocaleProvider>
  );
}
